<template>
  <div class="explain">
    <van-nav-bar :title="title" fixed placeholder @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" size="16" color="#323233" />
      </template>
    </van-nav-bar>
    <div
      class="div"
      v-if="index === 1"
      v-html="activityData.contributeSubmissionInstructions"
    ></div>
    <div class="div" v-if="index === 2" v-html="activityData.contributeSubmitDetails"></div>
    <div class="div" v-if="index === 3" v-html="activityData.photoContribute"></div>
    <div class="div" v-if="index === 4" v-html="activityData.paintingContribute"></div>
    <div class="div" v-if="index === 5" v-html="activityData.animeContribute"></div>
    <div class="div" v-if="index === 6" v-html="activityData.scienceContribute"></div>
    <!-- <div class="div" v-if="index === 7" v-html="activityData.contributeSubmissionInstructions"></div> -->

    <div class="btn">
      <van-button @click="btn">+上传{{ titleBtn }}</van-button>
    </div>
  </div>
</template>

<script>
import { getDetailActivity } from '@/api/activity'
export default {
  name: 'Explain',
  computed: {
    id() {
      return this.$route.query.id
    },
    index() {
      return this.$route.query.index * 1
    }
  },
  data() {
    return {
      activityData: {},
      title: '',
      titleBtn: ''
    }
  },
  created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    this.getTitle()
    this.getActivityData()
  },
  methods: {
    btn() {
      this.$router.push({
        name: 'UploadWorks',
        query: { id: this.id, index: this.index }
      })
    },
    async getActivityData() {
      // const url = 'https://imagecharacter.oss-cn-beijing.aliyuncs.com/'
      const { data: res } = await getDetailActivity({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang'),
        divisionName: ''
      })
      if (res.resultCode === 200) {
        this.activityData = res.data
      }
    },
    getTitle() {
      if (this.index === 1) {
        this.title = this.$t('message.explain.txt_xon')
        this.titleBtn = this.$t('message.explain.g_txt')
      } else if (this.index === 2) {
        this.title = this.$t('message.explain.voide_con')
        this.titleBtn = this.$t('message.explain.voide')
      } else if (this.index === 3) {
        this.title = this.$t('message.explain.photo_con')
        this.titleBtn = this.$t('message.explain.photo')
      } else if (this.index === 4) {
        this.title = this.$t('message.explain.pain_con')
        this.titleBtn = this.$t('message.explain.pain')
      } else if (this.index === 5) {
        this.title = this.$t('message.explain.animation_con')
        this.titleBtn = this.$t('message.explain.animation')
      } else if (this.index === 6) {
        this.title = this.$t('message.explain.scienfic')
        this.titleBtn = this.$t('message.explain.sci_work')
      } else if (this.index === 7) {
        this.title = this.$t('message.explain.music')
        this.titleBtn = this.$t('message.explain.sci_music')
      }
    },
    //点击返回
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.explain {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #fff;

  .div {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 16px;
    font-size: 14px;
    font-weight: 400;
    color: #1a1a1a;
    line-height: 1.5em;
    text-indent: 2em;

    p {
      font-size: 14px;
      font-weight: 400;
      color: #1a1a1a;
      line-height: 1.5em;
      text-indent: 2em;
    }

    img {
      max-width: 100%;
      margin: 10px auto;
    }
  }

  .btn {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    padding: 60px 20px 30px 20px;
    background-color: #fff;
    text-align: center;

    button {
      width: 240px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      padding: 0;
      border: none;
      background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
      box-shadow: 0px 0px 12px rgba(255, 192, 21, 0.2);
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      border-radius: 16px;
    }
  }
}
</style>
